// These correspond to the option values specified in the uploader
// component. The 4 listed here are the only ones we support
// (it is effectively an enum). The server accepts the string value
// of the enum (like "1w" etc.) and will verify that it is one of the 4 listed.
// We use an array for the values, so we can migrate all 30-days values
// to 28-days values.
export const expiryOptions = {
  '7d': [60 * 60 * 24 * 7],
  '14d': [60 * 60 * 24 * 14],
  '28d': [60 * 60 * 24 * 28, 60 * 60 * 24 * 30],
  '90d': [60 * 60 * 24 * 90],
  '365d': [60 * 60 * 24 * 365],
  never: [0],
};

export function convertExpiry(seconds) {
  if (typeof seconds === 'string') {
    return expiryOptions[seconds][0];
  }

  for (const name in expiryOptions) {
    if (expiryOptions[name].includes(seconds)) {
      return name;
    }
  }

  return false;
}
